<template>
    <form v-on:submit.prevent="validateBeforeSubmit">
		<div class="form-group">
            <ejs-combobox 
                id="process" 
                cssClass="e-outline"
                v-model="filters.type.value"
                :dataSource="filters.type.options"
                :fields="filters.type.optionsFields"
                :placeholder="$t('textReports.textFormTypeAffair')"
            />
        </div>

        <ejs-progressbutton 
            type="submit" 
            cssClass="e-primary" 
            ref="progressBtn" 
            :disabled="disabledButton"
            :spinSettings="spinSettings" 
            :duration="50000"
        >
            {{ $t("textBtn.btnSearch") }}
        </ejs-progressbutton>
    </form>
</template>

<script>
import axios from "axios";

export default {
    name: "reports-form-detail-affairs",
    props: ["tittle"],
    data() {
        return {
            filters: {
                type: {
                    value: null,
                    options: [
                        { value: "PRIVADO", text: "ASUNTOS PRIVADOS" },
                        { value: "PUBLICO", text: "ASUNTOS PUBLICOS" },
                    ],
			        optionsFields: { text: "text", value: 'value' },
                },
            },
            spinSettings: { position: "Right", width: 20 },
            disabledButton: false,
        };
    },
    methods: {
        validateBeforeSubmit: function () {
            this.enableButton(false);
            axios
                .post("/auth/reports/structuring/getAffairDetails", {
                    type: this.filters.type.value,
                })
                .then(({ data }) => {
                    const filters = this.filters.type.value 
                        ? this.filters.type.options.find(({ value }) => value === this.filters.type.value).text
                        : "";

                    Vue.prototype.$eventHub.$emit(
                        "loadDataReports",
                        this.$props.tittle,
                        data,
                        filters
                    );
                })
                .finally(() => {
                    this.enableButton(true);
                });
        },

        enableButton(status) {
            this.disabledButton = !status;
            //this don't appear that function.
            if (status && this.refs) {
                this.$refs.progressBtn.stop();
                this.$refs.progressBtn.refresh();
            }
        },
    },
};
</script>
